import labellingReducer from './labellingSlice';
import userReducer from './userSlice';
import liveAnalysisReducer from './liveAnalysisSlice';

export const reducers = {
  labelling: labellingReducer,
  user: userReducer,
  liveAnalysis: liveAnalysisReducer,
};
